/*
 * "Try free" buttons start the plugin download straight away.
 * Any link to the plugin page's #try-free section is caught:
 *   Mac -> Mac .pkg, Windows -> Windows .exe (URLs from theme settings,
 *   exposed as window.mtgDownloads in layout/theme.liquid).
 *   Phones, tablets (iPad too) and anything else follow the link to
 *   #try-free, which has both buttons.
 * Links marked data-mtg-dl="mac|windows" (the Try section buttons) download
 * as normal links; this only adds the note.
 * The licensing API's /api/plugin/latest has no CORS headers (checked 6 Oct
 * 2026), so the URLs come from theme settings, not a live fetch.
 */
(function () {
  var cfg = window.mtgDownloads || {};

  function detectComputer() {
    var uad = navigator.userAgentData;
    var ua = navigator.userAgent || '';
    var platform = (uad && uad.platform) || navigator.platform || '';
    if (uad && uad.mobile) return 'other';
    if (/Android|iPhone|iPad|iPod|Mobile|Silk|Kindle/i.test(ua)) return 'other';
    // iPadOS reports itself as a Mac; a Mac has no touch points.
    if (/Mac/i.test(platform) && navigator.maxTouchPoints > 1) return 'other';
    if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) return 'mac';
    if (/Win/i.test(platform) || /Windows/i.test(ua)) return 'windows';
    return 'other';
  }

  function showNote(link, computer) {
    var next = link.nextElementSibling;
    if (next && next.classList.contains('mtg-dl-note')) return;
    var note = document.createElement('p');
    note.className = 'mtg-dl-note';
    note.setAttribute('role', 'status');
    note.textContent = computer === 'mac' ? cfg.noteMac || '' : cfg.noteWindows || '';
    link.insertAdjacentElement('afterend', note);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;

    var marked = link.getAttribute('data-mtg-dl');
    if (marked === 'mac' || marked === 'windows') {
      showNote(link, marked);
      return; // normal download link
    }

    var href = link.getAttribute('href') || '';
    if (href.indexOf('#try-free') === -1) return;

    var computer = detectComputer();
    var url = computer === 'mac' ? cfg.mac : computer === 'windows' ? cfg.windows : '';
    if (!url) return; // phones, tablets, unknown: go to #try-free

    event.preventDefault();
    showNote(link, computer);
    window.location.href = url;
  });
})();
